import React, { Fragment } from 'react';
import {useSelector} from 'react-redux';


const Measurement = (props) => {
    const { measurementType } = useSelector((state) => state.measurement);
    
    return (
        <Fragment>
            <span>{parseInt(measurementType) === 0 ? props.measurementUnit.metrical : props.measurementUnit.imperial}</span>
        </Fragment>);
};

export default Measurement;
